<template>
  <div class="animated fadeIn">

    <b-card>
      <h2>
        {{$route.params.id ? 'Edit Listing' : 'New Listing'}}
        <div class="pull-right text-right">
          <div v-if="$route.params.id" class="mb-1">
            <c-switch :default-checked="listing.active" @change="(val) => listing.active = val" :label="true" size="lg" color="success" variant="pill" v-b-tooltip.hover :title="listing.active ? 'This listing is active and will be published at your scheduled times' : 'This listing is NOT active and will NOT be published'" />
          </div>
          <b-button-group>
            <b-button v-if="$route.params.id" size="lg" variant="outline-danger" :disabled="loading" @click="destroy()">Delete</b-button>
            <b-button v-if="$route.params.id" size="lg" variant="primary" :disabled="loading" @click="save()">Save</b-button>
            <b-button v-else size="lg" variant="primary" :disabled="loading" @click="save()">Create</b-button>
          </b-button-group>
        </div>
      </h2>
      <div class="lead">{{$route.params.id ? 'Edit advertisement listing or adjust scheduling' : 'Create a new advertisement listing'}}</div>

      <b-alert :show="!!error" variant="danger" class="mt-2 mb-0 py-2 px-3 d-flex align-items-center">
        <i class="icon-info mr-2"></i> {{error}}
      </b-alert>
      <b-alert :show="success" dismissible fade class="mb-0 mt-3" variant="success" @dismissed="success = false" @dismiss-count-down="(i) => success = i">Your listing has been {{$route.params.id ? 'updated' : 'created'}}!</b-alert>
    </b-card>

    <b-row>
      <b-col :lg="6">
        <basic :loading="loading" :details="listing" />
        <images :loading="loading" :listing-id="listing.id" :images.sync="listing.images" :image-shuffle.sync="listing.imageShuffle" />
        <schedule :loading="loading" :schedule="listing.schedule.days" @schedule-changed="scheduleChanged()" />
      </b-col>
      <b-col :lg="6">
        <kijiji :loading="loading" :kijiji="listing.kijiji" />

        <b-card data-block-disabled="Coming Soon!">
          <h4><img src="/img/publishers/craigslist.png" height="35" alt="Craigslist" /></h4>
          <b-form class="mt-3">
            <b-row>
              <b-col :sm="8">
                <b-form-group>
                  <label>Specific Location</label>
                  <b-form-input v-model="craigslist.specificLocation" type="text" placeholder="ex. 123 Main Street, City of Gold, Atlantis" />
                </b-form-group>
              </b-col>
              <b-col :sm="4">
                <b-form-group>
                  <label>Postal Code</label>
                  <b-form-input v-model="craigslist.postalCode" type="text" placeholder="ex. A1B 2C3" />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col :sm="6">
                <b-form-group>
                  <label>Posting Language</label>
                  <select class="custom-select">
                    <option selected>English</option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                  </select>
                </b-form-group>
              </b-col>
              <b-col :sm="6">
                <b-form-group>
                  <label>Condition</label>
                  <select class="custom-select">
                    <option selected>-</option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                  </select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="false">
              <b-col :sm="8">
                <b-form-group>
                  <label>Make / Manufacturer</label>
                  <b-form-input v-model="craigslist.makeManufacturer" type="text" />
                </b-form-group>
              </b-col>
              <b-col :sm="4">
                <b-form-group>
                  <label>Model Name / Number</label>
                  <b-form-input v-model="craigslist.modelNameNumber" type="text" />
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Switch as cSwitch } from '@coreui/vue'
import VueTreeselect from '@riophae/vue-treeselect'
import Basic from './form/Basic'
import Images from './form/Images'
import Schedule from './form/Schedule'
import Kijiji from './form/Kijiji'

export default {
  name: 'ListingForm',

  components: {
    cSwitch,
    VueTreeselect,
    Basic,
    Images,
    Schedule,
    Kijiji
  },

  props: {
    listing: {
      type     : Object,
      required : true,
    }
  },

  data(){
    return {
      craigslist: {
        specificLocation : '',
        postalCode       : '',
        makeManufacturer : '',
        modelNameNumber  : '',
      },

      // State
      loading : false,
      error   : '',
      success : false,
    }
  },

  methods: {
    save(){
      if( this.loading ){
        return
      }

      this.loading = true
      this.error = ''

      // Grab these now since they get set by the returned token
      const needsBilling = this.$session.get('dashboard.billing')
      const firstListing = this.$session.get('dashboard.listing')

      let call = ( this.$route.params.id ) ? this.$API.v2.Listings.Update(this.listing) : this.$API.v2.Listings.Create(this.listing)
      call.then((listing) => {
        this.$emit('update:listing', listing)
        this.success = 5

        // Creating
        if( !this.$route.params.id ){
          this.$router.push(`/listings/${listing.id}`)

          if( needsBilling && firstListing ){
            this.$nextTick(() => {
              this.$swal({
                title             : 'Congratulations!',
                text              : 'Great job setting up your first listing! Don\'t forget to activate your subscription so that we can start posting!',
                type              : 'success',
                showCloseButton   : true,
                showCancelButton  : true,
                cancelButtonText  : 'Dismiss',
                confirmButtonText : 'Let\'s go'
              })
              .then((resp) => {
                if( resp.value ){
                  this.$router.push({ name : "Account" })
                }
              })
            })
          }
        }
      })
      .catch((err) => {
        this.error = err
      })
      .then(() => {
        this.loading = false
      })
    },

    destroy(){
      this.$swal({
        title              : 'Confirmation Required',
        text               : 'Are you sure you want to delete this listing? This cannot be undone.',
        customClass        : 'confirm-modal',
        showCloseButton    : true,
        showCancelButton   : true,
        confirmButtonClass : 'bg-danger',
        confirmButtonText  : 'Yes, Delete It'
      })
      .then((result) => {
        if( result.dismiss ){
          return
        }

        this.loading = true
        this.$API.v2.Listings.Delete(this.listing.id)
        .then(() => {
          this.$router.push('/listings')
        })
        .catch((err) => {
          this.error = err
        })
        .then(() => {
          this.loading = false
        })
      })
      .catch((err) => {
        this.error = err
      })
    },

    scheduleChanged(){
      // Force save only if we've save the full listing
      if( this.$route.params.id ){
        this.save()
      }
    }
  }
};
</script>
